// src/App.js
import React from "react";
import GeoConfigNotice from "./geo/GeoConfigNotice";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginForm from "./components/modules/Login/LoginForm";
import Modules from "./components/modules/Modules";
import { UserProvider } from "./UserContext";
import ProtectedRoute from "./ProtectedRoute";
import "antd/dist/reset.css"; // Asegúrate de importar los estilos de Ant Design
import "./axiosConfig"; // Importar los interceptores de Axios antes de otros componentes
import { ConfigProvider } from "antd";
import esES from "antd/lib/locale/es_ES"; // Importar el locale español
import moment from "moment";
import "moment/locale/es"; // Importar la configuración regional de moment si lo usas
import "simplebar-react/dist/simplebar.min.css";
import { ConnectionProvider } from "./ConnectionContext"; // Importar ConnectionProvider
import { WebSocketProvider } from "./WebSocketContext"; // Importar WebSocketProvider
import { ServerTimeProvider } from "./ServerTimeContext"; // Importar ServerTimeProvider para sincronización de hora
import HomeRedirect from "./components/HomeRedirect"; // Importar HomeRedirect
import useVersionChecker from "./hooks/useVersionChecker"; // Hook para verificar versiones
import UpdateNotification from "./components/UpdateNotification"; // Componente de notificación
import ValidarControlServicio from "./components/public/ValidarControlServicio"; // Vista pública de validación
import ValidarFuec from "./components/public/ValidarFuec"; // Vista pública de validación FUEC

// Configurar moment para español (opcional)
moment.locale("es");

function App() {
  //const userId = 1;

  // Hook para verificar actualizaciones de versión
  const { currentVersion, serverVersion, isUpdateAvailable, forceUpdate } =
    useVersionChecker();

  // Manejar actualización
  const handleUpdate = () => {
    forceUpdate();
  };

  // Manejar dismissal de notificación
  const handleDismiss = () => {
    // Usuario decidió actualizar después
  };

  return (
    <ConfigProvider locale={esES}>
      <GeoConfigNotice />
      <UserProvider>
        <ServerTimeProvider>
          <ConnectionProvider>
            <WebSocketProvider>
              <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            {/* Componente de notificación de actualización */}
            <UpdateNotification
              isUpdateAvailable={isUpdateAvailable}
              currentVersion={currentVersion}
              serverVersion={serverVersion}
              onUpdate={handleUpdate}
              onDismiss={handleDismiss}
            />

            <Routes>
              {/* Usar HomeRedirect para la ruta raíz */}
              <Route path="/" element={<HomeRedirect />} />
              <Route path="/login" element={<LoginForm />} />

              {/* Ruta pública para validar control de servicio */}
              <Route
                path="/validar-control-servicio/:codigoQR"
                element={<ValidarControlServicio />}
              />

              {/* Ruta pública para validar FUEC */}
              <Route
                path="/validar-fuec/:codigo"
                element={<ValidarFuec />}
              />

              {/* Proteger la ruta /modules/* */}
              <Route
                path="/modules/*"
                element={
                  <ProtectedRoute>
                    <Modules />
                    {/* <ChatWidget userId={userId} /> */}
                  </ProtectedRoute>
                }
              />
            </Routes>
            </Router>
            </WebSocketProvider>
          </ConnectionProvider>
        </ServerTimeProvider>
      </UserProvider>
    </ConfigProvider>
  );
}

export default App;
